import { createTableSlice } from '../helpers';
import { TaskStatus } from '../../constants';

export const tableSlice = createTableSlice({
  name: 'labellerDashboard/todoTable',
  url: '/api/labelTasks',
  filters: {
    status: TaskStatus.TODO,
  },
});
